import 'bootstrap';
import 'popper.js';
import Auth0Lock from 'auth0-lock';

// Import actual app code
import '../src/geowb.js';
import {
  toggle_sat_2014_40cm_tiles,
  hamburgerClick
} from '../src/geowb.js';
window.toggle_sat_2014_40cm_tiles = toggle_sat_2014_40cm_tiles;
window.hamburgerClick = hamburgerClick;

// Import CSS
import 'mapbox-gl/dist/mapbox-gl.css';
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../src/custom.css';
import 'hamburgers/dist/hamburgers.css';

// auth0 authentication
const cid = '3qEYZAk8JEZqNfU619PLB8mghB1flDBB';
const domain = 'snowmaking.auth0.com';
const options = {
  oidcConformant: true,
  allowShowPassword: true,
  usernameStyle: 'email',
  avatar: null,
  closable: false,
  theme: {
    logo: 'https://wbsnowmaking.com/assets/img/icon.png',
    primaryColor: '#31324F'
  },
  languageDictionary: {
    emailInputPlaceholder: "you@vailresorts.com",
    title: "GeoWB"
  },
};

// Dirty hack to work around bug in auth0-lock.  Sets closable: false for password reset screen and allowLogin: false.
const optionsReset = {
  oidcConformant: true,
  allowShowPassword: true,
  usernameStyle: 'email',
  avatar: null,
  allowLogin: false,
  theme: {
    logo: 'https://wbsnowmaking.com/assets/img/icon.png',
    primaryColor: '#31324F'
  },
  languageDictionary: {
    emailInputPlaceholder: 'you@vailresorts.com',
    title: "GeoWB"
  },
};

const lock = new Auth0Lock(cid, domain, options);
const lockReset = new Auth0Lock(cid, domain, optionsReset);

lock.on('authorization_error', function (error) {
  console.log('authorization_error', error);
});


// check to see if visitor is logged in
lock.checkSession({}, function (error, authResult) {
  // if visitor is not authenticated show the lock screen
  if (error || !authResult) {
    lock.show({
      closable: false
    });
  } else {
    // if user has an active session
    lock.getUserInfo(authResult.accessToken, function (error, profile) {
      // set their email in the menu
      $('.ams-user').text(profile.email);
    });
  }
});

// Export/make authLogout available from the DOM
export function authLogout() {
  // return correct logout url based on process.env.NODE_ENV (passed from system to webpack to browser)
  function redirectEnv(){
    if (process.env.NODE_ENV === 'production') {
      return 'https://wb.alchemymapping.com';
    } else if (process.env.NODE_ENV === 'testing') {
      return 'https://testing.wb.alchemymapping.com';
    } else if (process.env.NODE_ENV === 'development') {
      return 'http://localhost:8080';
    }
  }
  lock.logout({
    returnTo: redirectEnv()
  });
}
window.authLogout = authLogout;

// Export/make authReset available from the DOM
export function authReset() {
  lockReset.show({
    initialScreen: 'forgotPassword'
  });
}
window.authReset = authReset;